import Vue from 'vue'
import axios from 'axios'
import {i18n} from '../../i18n'
import $ from 'jquery'
import _ from 'vue-lodash'

const state = {
    systemLanguages: [],
    selectedLanguage: {}
}

const getters = {
    systemLanguages(state) {
        return state.systemLanguages;
    },
    selectedLanguage(state) {
        return state.selectedLanguage;
    }
};

const mutations = {
    SET_SYSTEM_LANGUAGES(state, languages) {
        state.systemLanguages = languages;
    },
    SET_SELECTED_LANGUAGE(state, language) {
        state.selectedLanguage = language;
    },
    MODIFY_LANGUAGE(state, { updatedLanguage, imageVersion }) {
        const stateCopy = [];
        state.systemLanguages.forEach(lang => {
            if (lang.id === updatedLanguage.id) {
                lang = updatedLanguage;
                lang.flagImagePath += '?version=' + imageVersion;

                if (state.selectedLanguage.id === lang.id) {
                    state.selectedLanguage = lang;
                }
            }
            stateCopy.push(lang);
        });

        state.systemLanguages = stateCopy;
    },
};

const actions = {
    loadSystemLanguages: function(context) {
        return new Promise((resolve, reject) => {
            axios
                .get("/api/languages/list")
                .then(response => {
                    context.commit('SET_SYSTEM_LANGUAGES', response.data);
                    context.dispatch("applyDefaultLanguage");
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        })
    },
    applyDefaultLanguage: function (context) {
        return new Promise((resolve, reject) => {
            axios.get("/api/doctor/profile")
                .then(response => {
                    try {
                        context
                            .dispatch("selectLanguage", response.data.language)
                            .then(innerResponse => {
                                resolve(innerResponse);
                            }).catch(innerError => {
                                reject(innerError);
                            });
                    }
                    catch {
                        reject();
                    }
                })
                .catch(error => {
                    //reject(innerResponse);
                });
        });
    },
    selectLanguage: function(context, language) {
        context.commit('SET_SELECTED_LANGUAGE', language);
        let msgs;
        $.getJSON(language.translationsPath, json => {
            msgs = json
        }).then(() => {
            if($.isEmptyObject(i18n.getLocaleMessage(language.title))){
                i18n.setLocaleMessage(language.title, msgs)
            }
            i18n.locale = language.title
        });
    },
    updateLanguage: function (context, { langCode, code, name, imageVersion }) {
        return new Promise((resolve, reject) => {
            axios.put(`/api/languages/edit/${ langCode }`, {
                    "Title": code,
                    "LongTitle": name
                }).then(response => {
                    context.commit('MODIFY_LANGUAGE', { updatedLanguage: response.data, imageVersion });
                    resolve(response);
                }).catch(error => {
                    console.log(error)
                    reject(error);
                });
        });
    }
};

export default {
    state,
    getters,
    mutations,
    actions
};